"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAUNCH_ID_PATTERN = exports.APP_LAUNCH_END_REASONS = exports.isLiveAppLaunchState = exports.LIVE_APP_LAUNCH_STATES = exports.APP_LAUNCH_STATES = exports.PHASE1_APP_KINDS = exports.APP_KINDS = void 0;
exports.APP_KINDS = [
    "shiny",
    "jupyter",
    "marimo",
    "rstudio",
    "dash",
    "generic",
];
exports.PHASE1_APP_KINDS = [
    "shiny",
    "jupyter",
    "marimo",
];
exports.APP_LAUNCH_STATES = [
    "requested",
    "queued",
    "starting",
    "running",
    "stopping",
    "ended",
];
exports.LIVE_APP_LAUNCH_STATES = [
    "requested",
    "queued",
    "starting",
    "running",
    "stopping",
];
const isLiveAppLaunchState = (s) => s !== "ended";
exports.isLiveAppLaunchState = isLiveAppLaunchState;
exports.APP_LAUNCH_END_REASONS = [
    "user_stopped",
    "idle",
    "wall_time",
    "failed_to_start",
    "lost",
    "admin_stopped",
    "dispatch_refused",
];
exports.LAUNCH_ID_PATTERN = /^[a-z2-7]{26}$/;
